import { InvoiceDetail } from '@/api/useFreight/types'
import { PayrollLinkPopover } from '@/components/DriverManagement/Common/PayrollLinkPopover'
import { MaterialIcon, Texto } from '@gravitate-js/excalibrr'
import React from 'react'

interface LineItemTypeCellRendererProps {
  value: string
  data: InvoiceDetail
}

/**
 * Renders a line item type with appropriate icon
 */
export function LineItemTypeCellRenderer({ value, data }: LineItemTypeCellRendererProps): JSX.Element {
  let icon = null

  switch (value) {
    case 'Freight Rate':
      icon = <MaterialIcon fill size={14} icon='calculate' />
      break
    case 'Surcharge':
      icon = (
        <MaterialIcon
          fill
          size={14}
          style={{ color: 'var(--theme-success)', paddingTop: 1 }}
          icon='keyboard_capslock'
        />
      )
      break
    case 'Accessorial':
      icon = <MaterialIcon size={14} fill style={{ color: 'var(--theme-warning)', paddingTop: 1 }} icon='fact_check' />
      break
    case 'Point To Point':
      icon = <MaterialIcon size={14} fill icon='earbuds' />
      break
    default:
      icon = null
  }
  return (
    <Texto style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      {icon}
      {value}
      <PayrollLinkPopover linkedInfo={data?.linked_sp_info} timezone={data?.timezone} type='special pay' />
    </Texto>
  )
}
